document.addEventListener("DOMContentLoaded", function () {
  const redtabLoyaltyPageTriggerMobile = document.querySelector('#EazyRewardsPageTriggerMobile');
  if (redtabLoyaltyPageTriggerMobile) {
    redtabLoyaltyPageTriggerMobile.addEventListener('pointerenter', function () {
      window.dispatchEvent(new CustomEvent("redtab-page:open"));
    });
    redtabLoyaltyPageTriggerMobile.addEventListener('click', function () {
      window.dispatchEvent(new CustomEvent("redtab-page:open"));
    });
  }
});

(()=>{
  document.addEventListener("click", function(event){
    const targetEl = event.target;
    const SELECTORS = {
      CLASSNAME: {
        COLLECTION_PAGE: {
          MAIN_COLLECTION_2:{
            CLEAR_FILTERS: ".main-collection-2-clear-filter-btn",
            INLINE_FILTER: {
              PANEL_TRIGGER: ".product-grid-2-inline-filters__panel-trigger",
              FILTER_LABEL: ".product-grid-2-inline-filters__filter",
              VIEW_MORE: ".main-collection-2-inline-filters__view-more"
            },
            ACTIVE_FILTERS: {
              WRAPPER: "",
              ACTIVE_FILTER_TRIGGER: ".main-collection-2-active-filter"
            }
          }
        }
      }
    }

    /*
    * MAIN COLLECTION 2: CLEAR FILTER
    */
    if (targetEl.matches(".main-collection-2-clear-filter-btn")){
      document.dispatchEvent(new CustomEvent("main-collection-2:filters:clear"));
    }

    /*
    * MAIN COLLECTION 2 : INLINE FILTERS : START
    */ 
    
    // TAB/PANEL SWITCH
    if (targetEl.matches(SELECTORS.CLASSNAME.COLLECTION_PAGE.MAIN_COLLECTION_2.INLINE_FILTER.PANEL_TRIGGER)){
      document.dispatchEvent(new CustomEvent("main-collection-2:inline-filter-panel:change", {
        detail: {
          data: {
            targetEl: targetEl 
          }
        }
      }));
    }

    // LABEL CLICK
    if (targetEl.closest(SELECTORS.CLASSNAME.COLLECTION_PAGE.MAIN_COLLECTION_2.INLINE_FILTER.FILTER_LABEL)){
      targetEl.closest(SELECTORS.CLASSNAME.COLLECTION_PAGE.MAIN_COLLECTION_2.INLINE_FILTER.FILTER_LABEL).classList.add("is-loading");
    }

    // VIEW MORE CLICK
    if (targetEl.closest(SELECTORS.CLASSNAME.COLLECTION_PAGE.MAIN_COLLECTION_2.INLINE_FILTER.VIEW_MORE)){
      document.dispatchEvent(new CustomEvent("main-collection-2:inline-filter:view-more-btn-click", {
        detail: {
          data: {
            id: targetEl.closest(SELECTORS.CLASSNAME.COLLECTION_PAGE.MAIN_COLLECTION_2.INLINE_FILTER.VIEW_MORE).dataset.id
          }
        }        
      }));
    }

    /*
    * MAIN COLLECTION 2 : INLINE FILTERS : END
    */ 

    // ACTIVE FILTERS CLICK

    if (targetEl.closest(SELECTORS.CLASSNAME.COLLECTION_PAGE.MAIN_COLLECTION_2.ACTIVE_FILTERS.ACTIVE_FILTER_TRIGGER)){
      targetEl.closest(SELECTORS.CLASSNAME.COLLECTION_PAGE.MAIN_COLLECTION_2.ACTIVE_FILTERS.ACTIVE_FILTER_TRIGGER).classList.add("main-collection-2-active-filter--loading");
      document.dispatchEvent(new CustomEvent("main-collection-2:active-filter-click", {
        detail: {
          data: {
            element: targetEl.closest(SELECTORS.CLASSNAME.COLLECTION_PAGE.MAIN_COLLECTION_2.ACTIVE_FILTERS.ACTIVE_FILTER_TRIGGER)
          }
        }
      }))
    }

    if (targetEl.closest("[data-quick-swatch-click]")){
      document.dispatchEvent(new CustomEvent("quick-add-to-cart-product:change", {
        detail: {
          data: {
            target: targetEl.closest("[data-quick-swatch-click]"),
            url: targetEl.closest("[data-quick-swatch-click]")?.dataset.url
          }
        }        
      }));
    }

  });
})();